import { render } from "./NotificationView.vue?vue&type=template&id=21f07109&scoped=true"
import script from "./NotificationView.vue?vue&type=script&setup=true&lang=js"
export * from "./NotificationView.vue?vue&type=script&setup=true&lang=js"

import "./NotificationView.vue?vue&type=style&index=0&id=21f07109&scoped=true&lang=css"

import exportComponent from "/Volumes/Projects/wp_all_repo/wp-content/plugins/debug-log-config-tool/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21f07109"],['__file',"resources/views/NotificationView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "21f07109"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('21f07109', __exports__)) {
    console.log('reload')
    api.reload('21f07109', __exports__)
  }
  
  module.hot.accept("./NotificationView.vue?vue&type=template&id=21f07109&scoped=true", () => {
    console.log('re-render')
    api.rerender('21f07109', render)
  })

}


export default __exports__